import { ThemeConfig } from "antd/es/config-provider/context";

const defaultTheme: ThemeConfig = {
  token: {
    colorPrimary: "#c32dee",
    // colorFillSecondary: "##ffdb01",
    // colorBorderSecondary: "#f30300",
    borderRadius: 8,
    colorBgContainer: "#ffffff",
  },
};

const loginTheme: ThemeConfig = {
  components: {
    Card: {
      paddingLG: 48,
    },
    Input: {
      paddingBlock: 12,
    },
    Button: {
      controlHeight: 42,
    },
  },
};

export { loginTheme, defaultTheme };
